module.exports = __webpack_public_path__ + "static/media/dochilove05_ura.6f11a329.jpg";